import { LatestInteractionsPage } from './LatestInteractionsPage'
import { latestInteractionsPath } from './paths'

export const routes = [
  {
    path: latestInteractionsPath,
    component: LatestInteractionsPage,
    exact: true
  }
]
